import { Link as RouterLink } from 'react-router-dom'
import { Body } from 'src/components/typography'

interface LinkProps {
  label: string
  path: string
  onClick?: () => void
}

export const Link = ({ label, path, onClick }: LinkProps) => {
  return (
    <RouterLink to={path} onClick={onClick} style={{ padding: 10 }}>
      <Body $color="black" $fontWeight="semiBold" style={{ fontSize: 15 }}>
        {label}
      </Body>
    </RouterLink>
  )
}
